import { isEmpty, isNil } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import RffDateField from "../../../../../components/finalForm/inputs/RffDateField";
import RffDollarField from "../../../../../components/finalForm/inputs/RffDollarField";
import RffTextareaField from "../../../../../components/finalForm/inputs/RffTextareaField";
import RffTextField from "../../../../../components/finalForm/inputs/RffTextField";
import RffGroup from "../../../../../components/finalForm/shared/RffGroup";
import InsetCard from "../../../../../components/ui/InsetCard";
import { selectOptionsWireStatus } from "../../../../../constants/selectOptions/selectOptionsWireStatus";
import RffFormChanges from "../../../../../components/finalForm/RffFormChanges";
import PendingChangesBar from "../../../../../components/common/PendingChangesBar";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm, useFormState } from "react-final-form";
import { useLoanTermsHook } from "../../../../../hooks/useLoanTermsHook";
import { loanFetchedDataLoanTermsSet } from "../../../../../redux/reducers/loanFetchedDataReducer";
import RffSelectToggleField from "../../../../../components/finalForm/inputs/RffSelectToggleField";
import RffSelectField from "../../../../../components/finalForm/inputs/RffSelectField";

// const ITEM_NAME = "Originator Credit";
const LoanFeesSubTabWireInstructionsRedesign = () => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);

  // const rowData = useMemo(
  //   () => loanTerms?.originatorCredits || [],
  //   [loanTerms?.originatorCredits]
  // );
  // const headerSubtitle = useMemo(() => {
  //   if (isEmpty(rowData)) {
  //     return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
  //   }
  //   return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
  // }, [rowData]);

  // const onRowClicked = useCallback((d) => {
  //   dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_CREDIT));
  //   dispatch(sidebarSetParamsValue(null));
  //   dispatch(sidebarSetStateValue(d));
  // }, []);

  return <WireInstructionsContent />;
  return (
    <PrimaryContentCard
      maxWidth="md"
      title={"Wire Instructions"}
      // title={ITEM_NAME + "s"}
      // subTitle={headerSubtitle}
      // endContent={<LoanDrilldownButtonAddCredit />}
      loading={isNil(loanTerms)}
      // cardSx={{ pb: 0 }}
    >
      {/* <Box sx={{ p: 0, overflow: "hidden", mx: -4 }}>
        <OriginatorFeesTable onRowClicked={onRowClicked} rowData={rowData} />
      </Box> */}
      {/* <WireInstructionsContent /> */}
      <InsetCard sx={{ overflow: "hidden" }}>
        <WireInstructionsContent />
      </InsetCard>
    </PrimaryContentCard>
  );
};

/**
 * Reports the live form state up to `WireInstructionsContent`, and hands it the
 * form api.
 *
 * The floating save bar has to live OUTSIDE `<RffFormChanges>`: the form is
 * re-`key`ed every time `loanTerms.wireInstructions` changes, so a bar rendered
 * inside it would be torn down by the very save it just ran and never get to
 * play its "All changes saved" confirmation. So the bar sits outside and this
 * null-rendering bridge carries `dirty` / the changed-field count out, and the
 * form api (for submit + reset) back in.
 */
const FormStateBridge = ({ formRef, onDirtyChange }) => {
  const form = useForm();
  const { dirty, dirtyFields } = useFormState({
    subscription: { dirty: true, dirtyFields: true },
  });

  const count = useMemo(
    () => Object.keys(dirtyFields || {}).filter((k) => dirtyFields[k]).length,
    [dirtyFields],
  );

  useEffect(() => {
    formRef.current = form;
  }, [form, formRef]);

  useEffect(() => {
    onDirtyChange(dirty, count);
  }, [dirty, count, onDirtyChange]);

  return null;
};

const WireInstructionsContent = ({ children }) => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { updateLoanTermsObject, createLoanTermsObject } = useLoanTermsHook();
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState(null);
  const [formKey, setFormKey] = useState(0); // Key to force form re-initialization

  // Nothing here writes on change — edits are held locally until the floating
  // bar's Save (or ⌘S / Ctrl+S) is pressed.
  const [dirty, setDirty] = useState(false);
  const [dirtyCount, setDirtyCount] = useState(0);
  const [saving, setSaving] = useState(false);
  const formRef = useRef(null);

  const handleDirtyChange = useCallback((isDirty, count) => {
    setDirty(isDirty);
    setDirtyCount(count);
  }, []);

  const wireInstructionsData = loanTerms?.wireInstructions || {};

  // const handleOnUpdate = useCallback((changedData) => {
  //   console.log("Changed Data:", changedData);
  //   return;
  //   updateLoanTermsObjectData({
  //     loanId: loanDrilldown?._id,
  //     objectType: "wireInstructions",
  //     data: changedData,
  //     onSuccessFn: (response) => {
  //       dispatch(loanFetchedDataLoanTermsSet(response));
  //       if (!isEmpty(loanTerms)) {
  //         dispatch(loanFetchedDataLoanTermsSet(null));
  //       }
  //     },
  //   });
  // }, []);

  const isUpdating = useMemo(
    () => !isEmpty(loanTerms?.wireInstructions),
    [loanTerms?.wireInstructions],
  );

  const handleOnUpdate = useCallback(
    (changedData) => {
      if (isEmpty(changedData)) return;
      setSaving(true);

      const requestParams = {
        dealId: loanDrilldown?._id,
        objectType: "wireInstructions",
        data: changedData,
        onSuccessFn: (response) => {
          dispatch(loanFetchedDataLoanTermsSet(response));
          // Going clean here is what flips the bar into its "All changes
          // saved" confirmation before it slides away. On a failure `dirty`
          // stays true and the bar simply comes back out of its saving state.
          setDirty(false);
          setDirtyCount(0);
        },
        onCompleteFn: () => setSaving(false),
      };

      if (isUpdating) {
        updateLoanTermsObject(requestParams);
      } else {
        createLoanTermsObject(requestParams);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loanDrilldown?._id, isUpdating],
  );

  const handleSave = useCallback(() => {
    formRef.current?.submit();
  }, []);

  const handleDiscard = useCallback(() => {
    formRef.current?.reset();
  }, []);
  useEffect(() => {
    if (isNil(initialValues)) {
      setTimeout(() => {
        setInitialValues(wireInstructionsData);
        // setInitialValues(loanDrilldown);
        setFormKey((prev) => prev + 1); // Force form re-initialization
      }, 100);
    } else {
      // console.log("ELSE", loanDrilldown);
      setInitialValues(loanTerms?.wireInstructions);
      setFormKey((prev) => prev + 1);
    }
  }, [loanTerms?.wireInstructions]);
  return (
    <>
      <RffFormChanges
        key={formKey}
        // formSpy
        initialValues={initialValues}
        suppressFooter
        onSubmit={handleOnUpdate}
      >
        <FormStateBridge formRef={formRef} onDirtyChange={handleDirtyChange} />
        <RffGroup suppressBottomMargin>
          <RffDateField
            size={12 / 5}
            label="Wire Request Date"
            name="wireRequestDate"
          />
          {/* A negative wire is an INCOMING wire from title (what we withheld
              exceeds the advance) — funding-statements.md, 2026-10-05. */}
          <RffDollarField
            size={12 / 5}
            label="Wire Amount"
            name="wireAmount"
            allowNegative
            negativeHelperText="Incoming from title"
          />
          <RffSelectField
            size={12 / 5}
            label="Wire Status"
            name="wireStatus"
            options={selectOptionsWireStatus}
          />
          <RffTextField
            size={12 / 5}
            label="Wire Fed Ref Number"
            name="wireFedRefNumber"
          />
          <RffDateField
            size={12 / 5}
            label="Closing Wire Release Date"
            name="closingWireReleaseDate"
          />
          <RffTextareaField
            minHeight={80}
            // size={4}
            label="Wire Remarks/Notes"
            name="wireNotes"
          />
        </RffGroup>
      </RffFormChanges>

      <PendingChangesBar
        dirty={dirty}
        saving={saving}
        count={dirtyCount}
        onSave={handleSave}
        onDiscard={handleDiscard}
        label="Save wire ticket"
      />
    </>
  );
};

export default LoanFeesSubTabWireInstructionsRedesign;
// import { isEmpty, isNil } from "lodash";
// import { useDispatch, useSelector } from "react-redux";
// import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
// import RffDateField from "../../../../../components/finalForm/inputs/RffDateField";
// import RffDollarField from "../../../../../components/finalForm/inputs/RffDollarField";
// import RffSelectField from "../../../../../components/finalForm/inputs/RffSelectField";
// import RffTextareaField from "../../../../../components/finalForm/inputs/RffTextareaField";
// import RffTextField from "../../../../../components/finalForm/inputs/RffTextField";
// import RffForm from "../../../../../components/finalForm/RffForm";
// import RffGroup from "../../../../../components/finalForm/shared/RffGroup";
// import InsetCard from "../../../../../components/ui/InsetCard";
// import { selectOptionsWireStatus } from "../../../../../constants/selectOptions/selectOptionsWireStatus";
// import LoanDrilldownButtonAddCredit from "../../../buttons/LoanDrilldownButtonAddCredit";
// import RffFormChanges from "../../../../../components/finalForm/RffFormChanges";
// import UnsavedChangesAlert from "../../../../../components/common/UnsavedChangesAlert";
// import { useCallback, useEffect, useMemo, useState } from "react";
// import { useLoanTermsHook } from "../../../../../hooks/useLoanTermsHook";
// import { loanFetchedDataLoanTermsSet } from "../../../../../redux/reducers/loanFetchedDataReducer";
// import RffSelectToggleField from "../../../../../components/finalForm/inputs/RffSelectToggleField";
// import { object } from "prop-types";

// // const ITEM_NAME = "Originator Credit";
// const LoanFeesSubTabWireInstructionsRedesign = () => {
//   const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
//   const dispatch = useDispatch();

//   // const rowData = useMemo(
//   //   () => loanTerms?.originatorCredits || [],
//   //   [loanTerms?.originatorCredits]
//   // );
//   // const headerSubtitle = useMemo(() => {
//   //   if (isEmpty(rowData)) {
//   //     return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
//   //   }
//   //   return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
//   // }, [rowData]);

//   // const onRowClicked = useCallback((d) => {
//   //   dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_CREDIT));
//   //   dispatch(sidebarSetParamsValue(null));
//   //   dispatch(sidebarSetStateValue(d));
//   // }, []);

//   return (
//     <PrimaryContentCard
//       maxWidth="md"
//       title={"Wire Instructions"}
//       // title={ITEM_NAME + "s"}
//       // subTitle={headerSubtitle}
//       // endContent={<LoanDrilldownButtonAddCredit />}
//       loading={isNil(loanTerms)}
//       // cardSx={{ pb: 0 }}
//       bodySx={{ pt: 3 }}
//     >
//       <WireInstructionsContent />
//       {/* <InsetCard sx={{ overflow: "hidden" }}>
//         <WireInstructionsContent />
//       </InsetCard> */}
//     </PrimaryContentCard>
//   );
// };

// const WireInstructionsContent = ({ children }) => {
//   const loanDrilldown = useSelector((state) => state.loanDrilldown);
//   const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
//   const { loading, createLoanTermsObject, updateLoanTermsObject } =
//     useLoanTermsHook();
//   const dispatch = useDispatch();

//   const wireInstructionsInit = {
//     wireAmount: 32343,
//     closingWireReleaseDate: "2025-12-17T00:00:00.000Z",
//     wireNotes: "weqwe",
//     wireStatus: "Tee-up Done",
//   };
//   // const wireInstructionsInit = loanTerms?.wireInstructions || {};
//   const initData = useMemo(
//     () => loanTerms?.wireInstructions,
//     [loanTerms?.wireInstructions]
//   );

//   const initialValues = useMemo(() => {
//     return wireInstructionsInit;
//   }, [wireInstructionsInit]);

//   // const wireInstructionsInit = loanTerms?.wireInstructions || {};
//   const isUpdating = useMemo(
//     () => !isEmpty(initData),
//     [initData]
//     // const isUpdating = useMemo(
//     //   () => !isEmpty(loanTerms?.wireInstructions),
//     //   [loanTerms?.wireInstructions]
//   );
//   const [localInitialValues, setLocalInitialValues] = useState(null);
//   const [formKey, setFormKey] = useState(0); // Key to force form re-initialization

//   const handleOnUpdate = useCallback((changedData) => {
//     const requestParams = {
//       loanId: loanDrilldown?._id,
//       objectType: "wireInstructions",
//       data: changedData,
//       onSuccessFn: (response) => {
//         dispatch(loanFetchedDataLoanTermsSet(response));
//         // if (!isEmpty(loanTerms)) {
//         //   dispatch(loanFetchedDataLoanTermsSet(null));
//         // }
//       },
//     };

//     if (isUpdating) {
//       console.log("updating", requestParams);
//       // return;
//       // updateLoanTermsObject(requestParams);
//     } else {
//       console.log("creating", requestParams);
//       // return;
//       // createLoanTermsObject(requestParams);
//     }
//   }, []);

//   useEffect(() => {
//     if (isNil(localInitialValues)) {
//       setTimeout(() => {
//         setLocalInitialValues(initData);
//         setFormKey((prev) => prev + 1); // Force form re-initialization
//       }, 100);
//     } else {
//       // console.log("ELSE", loanDrilldown);
//       // setInitialValues(profile);
//       setFormKey((prev) => prev + 1);
//     }
//   }, [initData]);
//   return (
//     <RffFormChanges
//       formSpy
//       key={formKey}
//       initialValues={initData}
//       suppressFooter
//       onSubmit={handleOnUpdate}
//       hasChangesContent={
//         <UnsavedChangesAlert
//           loading={loading}
//           onCancel={() => {
//             setLocalInitialValues(initialValues);
//             setFormKey((prev) => prev + 1);
//           }}
//         />
//       }
//     >
//       <RffGroup suppressBottomMargin>
//         <RffDateField
//           size={6}
//           label="Wire Request Date"
//           name="wireRequestDate"
//         />
//         <RffDollarField size={6} label="Wire Amount" name="wireAmount" />
//         <RffSelectToggleField
//           label="Wire Status"
//           name="wireStatus"
//           options={selectOptionsWireStatus}
//         />
//         <RffTextField
//           size={6}
//           label="Wire Fed Ref Number"
//           name="wireFedRefNumber"
//         />
//         <RffDateField
//           size={6}
//           label="Closing Wire Release Date"
//           name="closingWireReleaseDate"
//         />
//         <RffTextareaField
//           minHeight={80}
//           // size={4}
//           label="Wire Remarks/Notes"
//           name="wireNotes"
//         />
//       </RffGroup>
//     </RffFormChanges>
//   );
// };

// export default LoanFeesSubTabWireInstructions;
